import styled from 'styled-components';

export const DecisionTextBox = styled.textarea`
    background: #ffffff;
    width: 300px;
    height: 50px;
    position: relative;
    border-radius: 7px;
    border: 1px solid #ccc;
    box-shadow: 1px 1px 1px #999;
`;


export const DecisionComponentDiv = styled.div`
    position: relative;
    margin-top: 100px;
    margin-left: 40%;
    margin-right: 40%;
    float: left
`;


export const DecisionLabel = styled.label`
    color: #000000;
    text-align: left;
    left: 1%;
    position: relative;
`;

export const ListOfDecisionsText = styled.div`
    background: #d9d9d9;
    border-radius: 7px;
    width: 358px;
    height: 102px;
    position: relative;
`; 

